import { fuseLoadingInterceptor } from '@fuse/services/loading';

import { authInterceptor } from './auth.interceptor';
import { errorInterceptor } from './error.interceptor';

// A12. One list, one `provideHttpClient`. There used to be a second call inside `provideFuse`
// carrying `fuseLoadingInterceptor` alone — it worked only because interceptor fns are
// multi-provided, while every non-multi HttpClient setting silently took the *last* call's
// value. Order matters and is deliberate: auth first, error mapping second, the loading
// counter last so it wraps the request the way the user sees it.
export const httpInterceptors = [
  authInterceptor,
  errorInterceptor,
  fuseLoadingInterceptor,
];
